import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_CHAT_LOG,
    getChatLogFail,
    getChatLogSuccess
} from '../action/getChatLogAction'

// api 
import getChatLogApi from '../api/getChatLogApi'

export function* getChatLogSaga(action) {
    try {
        const response = yield call(() => getChatLogApi(action.params))
        if (response.data.status === 1) {
            yield put(getChatLogSuccess(response, action))
        } else {
            yield put(getChatLogFail(response, action))
        }
    }
    catch (e) {
        yield put(getChatLogFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_CHAT_LOG, getChatLogSaga)
}